// LazyImage.jsx

import { useEffect, useRef, useState } from "react";
import { ImageOff } from "lucide-react";

export default function LazyImage({
  src,
  alt,
  className = "",
}) {
  const imageRef = useRef(null);

  const [isVisible, setIsVisible] = useState(false);

  const [loaded, setLoaded] = useState(false);

  const [error, setError] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);

          observer.disconnect();
        }
      },
      {
        rootMargin: "200px",
      },
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={imageRef}
      className={`
        relative overflow-hidden
        bg-gray-100
        ${className}
      `}
    >
      {!loaded && !error && (
        <div className="absolute inset-0 animate-pulse bg-gray-200" />
      )}

      {error ? (
        <div className="flex h-full items-center justify-center">
          <ImageOff
            size={24}
            className="text-gray-400"
          />
        </div>
      ) : (
        isVisible && (
          <img
            src={src || "/placeholder.png"}
            alt={alt}
            onLoad={() => setLoaded(true)}
            onError={() => setError(true)}
            className={`
              h-full w-full object-contain
              transition-opacity duration-500
              ${loaded ? "opacity-100" : "opacity-0"}
            `}
          />
        )
      )}
    </div>
  );
}